import { render, staticRenderFns } from "./FinancialRatios.vue?vue&type=template&id=36f70e80"
import script from "./FinancialRatios.vue?vue&type=script&lang=js"
export * from "./FinancialRatios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports